import React, { memo, useCallback } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import Triangle from './Triangle';
import Image from './Image';
import Desc from './Desc';
import styles from './PosterCard.module.less';
import { logging } from '../../actions/log';
import { setIframeVisible } from '../../actions/layout';
import { logNative } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const LOG_ACTION_SOURCE = {
    c_click: `${logInfo.tag}_HotSell`,
    c_hover: `${logInfo.tag}_HotSell_hover`,
    c_change: `${logInfo.tag}_HotSell_Change`,
    action: `${logInfo.tag}_HotSell`,
    source: `${logInfo.tag}_HotSell||${logInfo.code}`,
  };

  const handleSkip = useCallback(() => {
    if (data.targetType === '5' && data.targetContent) {
      let targetContent = {};
      try {
        targetContent = JSON.parse(data.targetContent);
      } catch (error) {
        logNative(`分析商城URL JSON解析错误:${error}`, error);
      }
      if (targetContent && targetContent.url) {
        dispatch(
          setIframeVisible({
            visible: true,
            url: targetContent.url,
            data,
            source: LOG_ACTION_SOURCE.source,
          }),
        );
      }
    } else if (data.targetType === '2' || data.targetUrl) {
      if (data.targetUrl) {
        window.open(data.targetUrl);
      } else {
        // 对data.targetUrl无值时做一个兼容处理
        let targetContent = {};
        try {
          targetContent = JSON.parse(data.targetContent);
          window.open(targetContent.targetUrl);
        } catch (error) {
          logNative(`分析商城URL JSON解析错误:${error}`, error);
        }
      }
    }
    // 点击card
    dispatch(
      logging({
        category: 'C',
        action: LOG_ACTION_SOURCE.action,
        label: '',
        param2: {
          source: LOG_ACTION_SOURCE.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          name: data.name,
          id: data.id,
          // sku:
        },
      }),
    );
  }, [data.targetUrl]);

  return (
    <div className={styles.item} onClick={handleSkip}>
      <Triangle data={data} />
      <Image data={data} />
      <Desc data={data} />
    </div>
  );
});
